// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__33EBB","title":"Images45_title__1ONI7","images":"Images45_images__2Uqn5"};